import { Directive, TemplateRef } from '@angular/core';

/**
 * Маркер шаблона тела строки для app-ui-table.
 * Используется так:
 *   <app-ui-table>
 *     <ng-template appUiTableBody let-row let-i="rowIndex"> ... </ng-template>
 *   </app-ui-table>
 *
 * Контекст шаблона:
 *   $implicit -> данные строки (row)
 *   rowIndex  -> индекс строки
 */
@Directive({
  selector: '[appUiTableBody]',
  standalone: true
})
export class UiTableBodyDirective {
  constructor(public template: TemplateRef<any>) {}
}
